(function() {
	/**
   * Renders Weather Station Map Page (new stations-data/*.json structure)
   * @param {Object} props - The routing and page context and properties
   * @returns {object} Promise with data (nav for menu, etc.)
   */
	WebBaseAprovLV.renderWeatherStationMapPage = function(props) {
		var Utils = WebBaseAprovLV.Utils;
		var lang = WebBaseAprovLV.lang;

		var params = {
			page: (props.context.params && props.context.params.page) || '',
			detail: (props.context.params && props.context.params.detail) || '',
			filter: props.scodeFilter || ''
		};
		if (!Utils || !Utils.fetchAsync || !Utils.getKKData) {
			console.error('[station-map] Utils missing');
			return $.Deferred().reject(new Error('Utils missing')).promise();
		}
		var fetchFresh = Utils.fetchAsync({ dataType: 'json', cache: false, timeout: 12000 });
		function safeJSON(call, defaultVal, label) {
			var dfd = $.Deferred();
			call
			.done(function(resp) {
				dfd.resolve(resp);
			})
			.fail(function(_jq, textStatus, err) {
				console.warn('[station-map] failed:', label || 'request', textStatus || '', err || '');
				dfd.resolve(defaultVal);
			});
			return dfd.promise();
		}
		var stationType = 'valley';
		var stationsUrl = 'stations-data/website/valley.json';
		if (params.filter === 'WS.SF') {
			stationType = 'mountain';
			stationsUrl = 'stations-data/website/mountain.json';
		} else if (params.filter === 'PG') {
			stationType = 'watercourse';
			stationsUrl = 'stations-data/website/watercourse.json';
		}
		var model = {
			element: null,
			template: 'templates/weather-station-map.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {},
				pageRaw: null,
				pageContent: null,
				navRaw: null,
				nav: null,
				alternateRouting: null,
				stationType: stationType,
				stationDataDate: null,
				stations: null,
				sensors: null
			}
		};
		var altRoutes = Utils.getAlternateMeteoStationRouting(params.page);
		var base = (WebBaseAprovLV.config.azureStorageUrl && WebBaseAprovLV.config.azureStorageUrl[lang]) || '';
		return $.when(
			Utils.getKKData('?system.type=page&elements.url[in]=' + encodeURIComponent(params.page) + '&depth=1'),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		)
		.then(function(pageXhr) {
			var pageRaw = Array.isArray(pageXhr) ? (pageXhr[0] || {}) : (pageXhr || {});
			model.data.pageRaw = pageRaw;
			model.data.navRaw = {};
			return $.when(
				safeJSON(fetchFresh(base + stationsUrl), { stations: [] }, 'stations'),
				safeJSON(fetchFresh(base + 'stations-data/website/sensor_type.json'), { sensor_type: [] }, 'sensor_types')
			);
		})
		.then(function(stationsResp, sensorTypeResp) {
			var stationsPayload = stationsResp || { stations: [] };
			var sensorTypePayload = sensorTypeResp || { sensor_type: [] };
			var sensorTypes = {};
			if (sensorTypePayload && Array.isArray(sensorTypePayload.sensor_type)) {
				sensorTypePayload.sensor_type.forEach(function(st) {
					if (st && st.code) {
						sensorTypes[String(st.code)] = st;
					}
				});
			}
			var stations = [];
			if (stationsPayload && Array.isArray(stationsPayload.stations)) {
				stations = stationsPayload.stations.map(function(s) {
					if (!s) { return s; }
					var name;
					switch (lang) {
						case 'de':
							name = s.name_de || s.name_it || s.name_en || s.name_lld;
							break;
						case 'it':
							name = s.name_it || s.name_de || s.name_en || s.name_lld;
							break;
						case 'lld':
							name = s.name_lld || s.name_de || s.name_it || s.name_en;
							break;
						case 'en':
							name = s.name_en || s.name_de || s.name_it || s.name_lld;
							break;
						default:
							name = s.name_de || s.name_it || s.name_en || s.name_lld;
							break;
					}
					var statusDesc;
					switch (lang) {
						case 'de':
							statusDesc = s.status_de || s.status_it || s.status_en || s.status_lld;
							break;
						case 'it':
							statusDesc = s.status_it || s.status_de || s.status_en || s.status_lld;
							break;
						case 'lld':
							statusDesc = s.status_lld || s.status_de || s.status_it || s.status_en;
							break;
						case 'en':
							statusDesc = s.status_en || s.status_de || s.status_it || s.status_lld;
							break;
						default:
							statusDesc = s.status_de || s.status_it || s.status_en || s.status_lld;
							break;
					}
					s.NAME = name || s.code || '';
					s.SCODE = s.code || '';
					s.STATUSDESC = statusDesc || '';
					s.elevation = (s.elevation != null)
						? parseInt(s.elevation, 10)
						: (s.ALT != null ? parseFloat(s.ALT) : null);
					return s;
				});
				stations.sort(function(a, b) {
					return String(a.NAME || '').localeCompare(String(b.NAME || ''));
				});
			}
			var sensors = [];
			stations.forEach(function(station) {
				var stats = Array.isArray(station.statistics) ? station.statistics : [];
				stats.forEach(function(stat) {
					if (!stat || stat.sensorCode == null) { return; }
					var code = String(stat.sensorCode);
					var meta = sensorTypes[code] || {};
					var rawVal = stat.sensorValue;
					var rawDate = stat.sensorLastValidDate;
					var numVal = null;
					var hasNumericVal = false;
					if (typeof rawVal === 'number') {
						numVal = rawVal;
						hasNumericVal = true;
					} else if (typeof rawVal === 'string') {
						var trimmed = rawVal.trim();
						if (trimmed !== '' && trimmed.toLowerCase() !== 'null' && trimmed.toLowerCase() !== 'unknown') {
							if (trimmed.indexOf(':') === -1) {
								var parsed = parseFloat(trimmed.replace(',', '.'));
								if (!isNaN(parsed)) {
									numVal = parsed;
									hasNumericVal = true;
								}
							}
						}
					}
					var lastDate = null;
					if (typeof rawDate === 'string') {
						var dTrim = rawDate.trim();
						if (dTrim &&
							dTrim.toLowerCase() !== 'unknown' &&
							!isNaN(Date.parse(dTrim))) {
							lastDate = dTrim;
						}
					}
					if (code === 'LF' && hasNumericVal) {
						if (numVal > 100) {numVal = 100;}
						if (numVal < 0) {numVal = 0;}
					}
					var sensor = {
						SCODE: station.SCODE || station.code || '',
						TYPE: code,
						UNIT: meta.unit || '',
						DESC_D: meta.name_de || '',
						DESC_I: meta.name_it || meta.name_de || '',
						DESC_L: meta.name_lld || meta.name_de || '',
						DESC_E: meta.name_en || meta.name_de || '',
						VALUE: null,
						LASTDATE: lastDate
					};
					if (hasNumericVal) {
						sensor.VALUE = numVal;
					} else if (typeof rawVal === 'string') {
						sensor.VALUE = rawVal.trim();
					} else {
						sensor.VALUE = null;
					}
					if (code === 'GS' && hasNumericVal) {
						sensor.VALUE = Math.round(numVal);
					}
					if ((code === 'WG' || code === 'WG.BOE')) {
						if (hasNumericVal) {
							sensor.VALUE = (numVal * 3.6).toFixed(1);
							sensor.UNIT = 'km/h';
						} else {
							sensor.VALUE = null;
							if (!sensor.UNIT) {
								sensor.UNIT = 'km/h';
							}
						}
					}
					if (code === 'SSD' || code === 'SD') {
						if (typeof rawVal === 'number' && isFinite(rawVal)) {
							var totalSeconds = rawVal;
							var hours = Math.floor(totalSeconds / 3600);
							var minutes = Math.floor((totalSeconds % 3600) / 60);
							sensor.VALUE = hours + ':' + (minutes < 10 ? '0' + minutes : minutes);
							sensor.UNIT = 'h:mm';
						} else if (typeof rawVal === 'string') {
							var sTrim = rawVal.trim();
							if (sTrim.toLowerCase() === 'unknown' || sTrim === '') {
								sensor.VALUE = null;
							} else {
								sensor.VALUE = sTrim;
							}
							sensor.UNIT = 'h:mm';
						} else {
							sensor.VALUE = null;
							sensor.UNIT = 'h:mm';
						}
					}
					if (sensor.VALUE === 'unknown' || sensor.VALUE === 'null' || sensor.VALUE === '') {
						sensor.VALUE = null;
					}
					sensors.push(sensor);
				});
			});
			model.element = $('#content');
			model.data = $.extend(model.data, {
				pageContent: (Utils.getKKViewModel(model.data.pageRaw)[0]) || {},
				nav: (Utils.getKKViewModel(model.data.navRaw)[0]) || {},
				alternateRouting: altRoutes,
				stationType: stationType,
				stationDataDate: (typeof stationsPayload.date === 'string' && stationsPayload.date.trim()) ? stationsPayload.date.trim() : null,
				stations: stations,
				sensors: sensors
			});
			return Utils.transitionTo(model);
		})
		.then(function(ejsmodel) {
			ejsmodel.data.UILangSwitch = Utils.tuneUILangSwitchers({
				page: {
					segment: {
						'de': (altRoutes.de || '') + '/' + (params.detail || ''),
						'it': (altRoutes.it || '') + '/' + (params.detail || ''),
						'lld': (altRoutes.lld || '') + '/' + (params.detail || ''),
						'en': (altRoutes.en || '') + '/' + (params.detail || '')
					}
				},
				detail: {
					id: (('' || {}).system_id || '')
				}
			}, $('a.langchange'));
			return ejsmodel;
		})
		.promise();
	};
})();
